export default {
  strict: true,
  namespaced: true,
  state: {
    users: {
      list: [],
      currentPage: 1,
      perPage: 20,
      isLoading: false,
      maxList: 0,
      order: 'created',
      orderAsc: 0,
      seach: ''
    }
  },
  mutations: {
    resetUsers (state) { state.users.list = [] },
    addUser (state, value) { state.users.list = value },
    setUserMaxList (state, value) { state.users.maxList = value },
    setUserCurrentPage (state, value) { state.users.currentPage = value },
    setUserPerPage (state, value) { state.users.perPage = value },
    setUserOrder (state, value) { state.users.order = value },
    setUserOrderAsc (state, value) { state.users.orderAsc = value },
    setUserIsLoading (state, value) { state.users.isLoading = value },
    setUserSearch (state, value) { state.users.search = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/users.js